// extracted by mini-css-extract-plugin
export default {"status":"ChangeOrderStatus_status__f9u5o","card":"ChangeOrderStatus_card__aNAE8"};